export const getFeedGroup = (filters: string[]) => {
  if (!filters.length) return 'global'
  return filters.join('_')
}

const getUsernameForWatermark = (username: string) => {
  if (username.length > 8) {
    return `${username.slice(0, 8)}...`;
  }

  return username;
};

const getFirstPartVideoWatermark = (username: string) => `l_firstPartWatermark.svg,w_2.1/fl_layer_apply,so_0,eo_50p,x_0.05,g_north_east,y_0.05/l_text:watermarkFont.ttf_20_center:@${getUsernameForWatermark(
  username,
)},co_white,w_100/fl_layer_apply,g_center,y_-420,x_215,eo_50p`;

const getSecondPartVideoWatermark = (username: string) => `/l_firstPartWatermark.svg,w_2.1/fl_layer_apply,so_50p,eo_100p,g_south,y_75/l_text:watermarkFont.ttf_20_center:@${getUsernameForWatermark(
  username,
)},co_white,w_100/fl_layer_apply,g_south,y_50,x_0,so_50p,eo_100p`;

const getEndVideoWatermark = (username: string) => `/c_scale,h_1280,w_720/fl_splice,l_video:eyeball_watermark.mp4/c_scale,h_1280,w_720/co_rgb:9756E2,l_text:watermarkFont.ttf_38:@${getUsernameForWatermark(
  username,
)},so_2,g_south,y_468,fl_layer_apply/`;

export const getVideoWithWatermark = (username: string, url: string) => url.replace(
  'video/upload/',
  `video/upload/${getFirstPartVideoWatermark(
    username,
  )}${getSecondPartVideoWatermark(username)}${getEndVideoWatermark(username)}`,
);
